import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {};
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: '16px 0 0',
      paddingBottom: '0 !important',
    },
  };
});

export { useStyles, customCardStyles };
